import dynamic from 'next/dynamic';
import A from './components/A';
import css from './index.module.scss';
import EfScrollAni from '@/efscrollani';

const Dynamic = dynamic(() => import('./indexDynamic'), { ssr: true });

export default function Overview({}: any) {
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    return (
        <div className={`ecoflow-app-pc ${css.efAppPC}`}>
            <A />
            <Dynamic />
        </div>
    );
}
